import React, { useCallback } from 'react'
import { useNavigate, NavigateFunction } from 'react-router-dom'

import { t } from '@/i18n'
import { IBreadcrumb, IReport } from '@/types'
import { AppLayout, Breadcrumbs, LanguageSelector } from '@/components'
import { homePath, makeSearchPath, reportsPath } from '@/utils/index'
import { useData } from './useData'
import Form from './form'

const breadcrumbs: IBreadcrumb[] = [
  {
    name: 'search',
    path: homePath,
  },
  {
    name: 'add_report',
  },
]

const AddReport: React.FC = () => {
  const navigate: NavigateFunction = useNavigate()
  const { data, loading, submitting, onCancel, onSubmit } = useData({})

  const onSubmitForm = useCallback(
    (d: IReport) => {
      onSubmit('reports/', false, res => {
        const viewPath = makeSearchPath(reportsPath, {
          id: res.id,
          customerId: 'customer',
        })
        navigate(viewPath)
      })(d)
    },
    [navigate, onSubmit],
  )

  return (
    <AppLayout
      hasFooter
      headerRight={
        <div className="app-right-container">
          <LanguageSelector />
        </div>
      }
    >
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <div className="page-container">
        <div className="container">
          <div className="page-content">
            <div className="content-box">
              <div className="scroll-wrap">
                <div className="content-title">
                  <h2>{t('add_report')}</h2>
                </div>
                <Form
                  isEditing
                  loading={loading}
                  submitting={submitting}
                  initialData={data}
                  onCancel={onCancel}
                  onSubmit={onSubmitForm}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppLayout>
  )
}

export default AddReport
